angular.module('PinMeTo.services').factory('csvInjectionValidator', [
	function () {
		'use strict';

		const invalidCharacters = ['=', '/', '|', '"', '@', '+', '-', '\t', '\r'];

		const separators = [',', ';', "'", '"'];

		function isInputValid(string) {
			const inputCharacters = Array.from(string);

			function isFirstNotAllowed(maybeChar) {
				if (maybeChar) {
					return invalidCharacters.includes(maybeChar);
				} else {
					return false;
				}
			}

			function checkCharactersValidity(chars) {
				if (chars.length === 0) {
					return false;
				} else if (chars.length >= 2) {
					const [char1, char2, ...rest] = chars;
					if (separators.includes(char1) && invalidCharacters.includes(char2)) {
						return true;
					} else {
						return checkCharactersValidity([char2, ...rest]);
					}
				} else {
					return false;
				}
			}

			if (isFirstNotAllowed(inputCharacters[0])) {
				return false;
			} else {
				return !checkCharactersValidity(inputCharacters);
			}
		}

		return {
			isInputValid: isInputValid
		};
	}
]);
